@if (customer()) {
  <div class="cds-flex cds-flex-col xl:cds-flex-row sm:cds-m-3 cds-gap-5">
    <div class="card">
      <h2 class="cds-font-desktop-headline-1-roman cds-text-desktop-headline-5-roman">Personal Details</h2>
      <div class="data">
        <p>First Name</p>
        <p class="cds-font-bold" data-testid="personal-details-first-name">{{ customer().firstName }}</p>
      </div>
      <div class="data">
        <p>Last Name</p>
        <p class="cds-font-bold" data-testid="personal-details-last-name">{{ customer().lastName }}</p>
      </div>
      <div class="data">
        <p>Age</p>
        <p class="cds-font-bold" [class]="{ 'cds-text-red-700': dobError() }" data-testid="personal-details-age">
          {{ customer().age }}
        </p>
      </div>
      <div class="data">
        <p>Date of Birth</p>
        <p class="cds-font-bold" [class]="{ 'cds-text-red-700': dobError() }" data-testid="personal-details-dob">
          {{ customer().dateOfBirth | date: 'dd/MM/yyyy' }}
        </p>
      </div>
    </div>
    @if (customer().age! >= 19) {
      <div class="card">
        <div class="data">
          <p>Gender</p>
          <p class="cds-font-bold" data-testid="personal-details-gender">{{ genderValue() }}</p>
        </div>
        <div class="data">
          <p>Smoker</p>
          <p class="cds-font-bold" data-testid="personal-details-smoker">{{ smokerValue() }}</p>
        </div>
        <div class="data">
          <p>Occupation Class</p>
          <p class="cds-font-bold" data-testid="personal-details-occupation">
            {{ customer().occupation?.class || 'None Specified' }}
          </p>
        </div>
      </div>
    }
  </div>
}
